import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Product } from '../../../models/product.model'

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: 'confirmation_dialog.component.html',
  styleUrls: ['./confirmation_dialog.component.scss'],
})
export class ConfirmationDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {product: Product}
  ) {
  }
}
